import { render, staticRenderFns } from "./_SalesItemBlock.vue?vue&type=template&id=2537a2fe&scoped=true&"
import script from "./_SalesItemBlock.vue?vue&type=script&lang=js&"
export * from "./_SalesItemBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537a2fe",
  null
  
)

export default component.exports